const mb_row_isShow = {
  namespaced: true,
  state: {
    eye_btn_isShow:false,//眼睛按钮是否显示
    row_btn_isShow:false,//row上按钮是否显示
  },
  mutations: {
    SET_isShow(state, val) {
      state.row_btn_isShow = val;
    },
    SET_eye_btn_isShow(state, val) {
      state.eye_btn_isShow = val;
    },




  },
  actions: {


  }

};


export default mb_row_isShow;



// WEBPACK FOOTER //
// ./src/vuex/modules/mb_row_isShow.js